import { useState, useCallback } from 'react';

/**
 * Hook for managing flowchart zoom state and handlers
 */
export function useFlowchartZoom(containerRef, pan, setPan) {
  const [zoom, setZoom] = useState(1);

  // Handle zoom with scroll wheel (zoom towards cursor)
  const handleWheel = useCallback((e) => {
    e.preventDefault();
    
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    
    // Calculate zoom factor
    const delta = e.deltaY > 0 ? 0.92 : 1.08;
    const newZoom = Math.min(Math.max(zoom * delta, 0.25), 2);
    
    // Zoom towards cursor position
    const zoomRatio = newZoom / zoom;
    const newPanX = mouseX - (mouseX - pan.x) * zoomRatio;
    const newPanY = mouseY - (mouseY - pan.y) * zoomRatio;
    
    setZoom(newZoom);
    setPan({ x: newPanX, y: newPanY });
  }, [zoom, pan, containerRef, setPan]);

  // Zoom controls
  const handleZoomIn = useCallback(() => {
    setZoom(prev => Math.min(prev * 1.2, 2));
  }, []);

  const handleZoomOut = useCallback(() => {
    setZoom(prev => Math.max(prev * 0.8, 0.25));
  }, []);

  return {
    zoom,
    setZoom,
    handleWheel,
    handleZoomIn,
    handleZoomOut,
  };
}

